<template>
  <div class="project" v-if="!flush">
    <basic-container>
      <div class="form-header">
        <div class="add-header-wrapper">
          <div class="add-header">
            <div class="left-title">
              {{ info.id ? "项目编辑" : "新增项目" }}
            </div>
            <el-button
              size="small"
              plain
              type="primary"
              class="back-btn"
              style="margin-right: 20px; margin-bottom: 0; background: #fff"
              @click="back"
            >
              返回
            </el-button>
          </div>
          <div class="desc" v-if="info.id">{{ info.projectName }}</div>
        </div>
        <el-tabs v-model="activeName" v-if="info.id">
          <el-tab-pane label="项目信息" name="info"></el-tab-pane>
          <el-tab-pane
            label="地块名称"
            name="lands"
            v-if="info.id"
          ></el-tab-pane>
          <el-tab-pane
            label="车队名称"
            name="teamName"
            v-if="info.id"
          ></el-tab-pane>
          <el-tab-pane
            label="挖机型号"
            name="excavatoModel"
            v-if="info.id"
          ></el-tab-pane>
          <el-tab-pane
            label="成本设置"
            name="costSet"
            v-if="info.id"
          ></el-tab-pane>
          <el-tab-pane
            label="修改记录"
            name="updateRecord"
            v-if="info.id"
          ></el-tab-pane>
          <!-- <el-tab-pane label="装货起点" name="startPoint" v-if="info.id"></el-tab-pane> -->
        </el-tabs>
      </div>
      <div
        class="form-content"
        :style="{ marginTop: info.id ? '120px' : '30px' }"
      >
        <addOrEditProject
          v-if="activeName == 'info'"
          @addAfter="addAfter"
          :info="info"
        ></addOrEditProject>
        <setSecondaryPlots
          v-show="activeName == 'lands'"
          :info="info"
        ></setSecondaryPlots>
        <setFleetName v-if="activeName == 'teamName'" :info="info"></setFleetName>
        <setStartPoint
          v-if="activeName == 'startPoint'"
          :info="info"
        ></setStartPoint>
        <phaseSettings v-if="activeName == 'costSet'" :info="info"></phaseSettings>
        <personEditLog
          v-if="activeName == 'updateRecord'"
          :info="info"
        ></personEditLog>
        <setExcavatorModel
          v-if="activeName == 'excavatoModel'"
          :info="info"
        ></setExcavatorModel>
      </div>
    </basic-container>
  </div>
</template>

<script>
import personEditLog from "./personEditLog.vue";
import phaseSettings from "./phaseSettings.vue";
import addOrEditProject from "./projectOper/addOrEditProject.vue";
import setExcavatorModel from "./setExcavatorModel.vue";
import setFleetName from "./setFleetName.vue";
import setSecondaryPlots from "./setSecondaryPlots.vue";
import setStartPoint from "./setStartPoint.vue";
import { getObj } from "@/api/chain/projectinfo";
export default {
  data() {
    return {
      activeName: "info",
      info: {},
      flush: false,
    };
  },
  components: {
    addOrEditProject,
    setSecondaryPlots,
    setFleetName,
    setStartPoint,
    phaseSettings,
    personEditLog,
    setExcavatorModel,
  },
  created() {
    this.info = JSON.parse(this.$route.query.info);
    console.info(this.info, "--------");
  },
  methods: {
    addAfter(id) {
      this.flush = true;

      getObj(id).then((res) => {
        this.info = res.data.data;
        let labelList = [
              "leadingIds",
              "memberIds",
              "listSoilType",
              "garbageIds",
            ]; //多选转格式
            labelList.forEach((label) => {
              if (this.info[label] && this.info[label].length > 0) {
                let arr = this.info[label].split(",");
                let arr2 = [];
                if (arr.length > 1) {
                  arr.forEach((item2) => {
                    arr2.push(item2);
                  });
                } else {
                  arr2 = arr;
                }
                this.info[label] = arr2;
              } else {
                this.info[label] = [];
              }
            });
        this.flush = false;
      });
    },
    back() {
      this.$router.push({
        path: "/chain/project/projectinfo2",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-header-wrapper {
  // margin-bottom: 24px;

  .add-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left-title {
      font-weight: 500;
      font-size: 16px;
      color: #313133;
    }
  }
  .desc {
    margin-top: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #626266;
  }
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px;
  background: #ededf0;
}
/deep/.el-tabs__item {
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  height: 48px;
  line-height: 48px;
}
/deep/.el-tag {
  background: #fff;
  border-radius: 3px;
  border: 1px solid #ededf0;
  font-weight: 400;
  font-size: 12px;
  color: #313133;
  height: 24px;
  line-height: 21px;
}
/deep/.el-icon-close {
  color: #35b1ff;
}
/deep/.add-tag {
  background: #fff !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #35b1ff !important;
  height: 24px;
  line-height: 0;
  &:hover {
    font-weight: 400 !important;
    font-size: 12px !important;
    color: #35b1ff !important;
  }
}
.form-header {
  position: absolute;
  z-index: 999;
  background: #fff;
  right: 16px;
  left: 16px;
  padding: 0 16px;
  top: 0;
  padding-top: 16px;
}
/deep/.avue-group__header {
  margin-bottom: 0;
}
.form-content {
  margin-top: 100px;
}
/deep/.el-tabs__header {
  margin-bottom: 0;
}
.back-btn{
  &:hover{
    color: #35b1ff!important;
  }
}
</style>